import request from '@/common/js/request.js'

// 热门搜索
export function fetchHotTag (obj) {
  return request({
    url: '/tagmanager/selectTagsByNameAndStatus',
    method: 'get',
    params: obj
  })
}


// WEBPACK FOOTER //
// ./src/api/tag.js